<template>
  <div class="referral-sticky-toolbar d-flex bg-secondary p-2 text-right" ref="refStickyToolbar">
    <router-link
      class="ml-auto text-light"
      :to="'/referral/print/' + referral.id"
      title="Print Referral"
      target="_blank"
    >
      <font-awesome-icon :icon="['far', 'print']" />
    </router-link>
    <a
      href="javascript:void(0)"
      class="mx-3 text-light"
      @click="downloadPdf"
      title="Download Referral"
      :disabled="isDownloadingPdf"
    >
      <font-awesome-icon icon="spinner-third" spin v-if="isDownloadingPdf" />
      <template v-else>
        <font-awesome-icon :icon="['far', 'download']" />
      </template>
    </a>
  </div>
</template>

<script>
import client from '@/http-client'
import moment from 'moment'
export default {
  props: {
    referralId: { required: true },
  },
  data() {
    return {
      isDownloadingPdf: false,
    }
  },
  async mounted() {
    const observer = new IntersectionObserver(([e]) => e.target.toggleAttribute('stuck', e.intersectionRatio < 1), {
      threshold: [1],
    })

    observer.observe(this.$refs.refStickyToolbar)
  },
  computed: {
    referral() {
      return this.referralId ? this.$store.getters['referrals/get'](this.referralId) : { to_practice: { name: 'test' } }
    },
  },
  methods: {
    async downloadPdf() {
      this.isDownloadingPdf = true
      try {
        this.$track('$referralPdfDownload')
        const response = await client.get(`${process.env.VUE_APP_API_BASE_URL}/api/referrals/${this.referralId}/pdf`)
        if (!response.ok) throw new Error('Failed to generate PDF. Error: ' + response.status)
        const blob = await response.blob()
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `Refera_Referral_${this.referral.patient_firstname || ''}_${
          this.referral.patient_lastname?.[0] || ''
        }_${moment().format('YYYY-MM-DD')}_${this.referralId}.pdf`
          .replace('___', '_')
          .replace('__', '_')
        document.body.appendChild(a) // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click()
        a.remove()
      } catch (err) {
        this.$helpers.error((err && err.message) || 'Failed to create PDF')
      }
      this.isDownloadingPdf = false
    },
  },
}
</script>

<style lang="scss" scoped>
.referral-sticky-toolbar {
  font-size: 1.1rem;
  position: sticky;
  top: -1px; //this allows the intersectionobserver to fire as it is just outside its container
  z-index: 9;
  color: white;

  transition: background 0.8s ease-out;

  &[stuck]:not(:hover) {
    background: #012b30d9 !important;
  }
}
</style>